import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import i18n from './common/plugins/vue-i18n'

// import cookie
var VueCookie = require('vue-cookie');
Vue.use(VueCookie)

// import axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// import bootstrap
import './plugins/bootstrap-vue'

// import router
import VueRouter from 'vue-router'
import { routes } from './routes'
Vue.use(VueRouter);

// import form generator
import VueFormGenerator from 'vue-form-generator'
import VueTelInput from 'vue-tel-input'
import TelInputField from "./components/tel-input-field.vue";
import 'vue-form-generator/dist/vfg.css'
Vue.use(VueFormGenerator)
Vue.use(VueTelInput)
Vue.component("field-tel-input", TelInputField);

// register password input
import NewPasswordInputField from "./components/new-password-input-field.vue";
Vue.component("field-new-password", NewPasswordInputField);

// import css
import '@/styles/style.css' // style css

// set config
Vue.config.productionTip = false

// set router
const router = new VueRouter({
  routes,
  mode: 'history'
});

// start app
new Vue({
  i18n,
  el: '#app',
  router,
  render: h => h(App),
});

// set global plugins
import zipcode from 'japan-postal-code'
Vue.prototype.$zipcode = zipcode
